import { MatchesProps } from '@nexelem/navigation';
import { UseQueryResult, useQueries } from '@tanstack/react-query';
import { useMatches } from 'react-router-dom';
import { Breadcrumb } from './Breadcrumb';

export const Breadcrumbs = () => {
  const matches = useBreadcrumbs();

  return (
    <div className="ml-3 flex items-center">
      {matches.map(({ match, titleQuery }, index, allMatches) => (
        <Breadcrumb isLast={index === allMatches.length - 1} key={match.id} match={match} titleQuery={titleQuery} />
      ))}
    </div>
  );
};

const useBreadcrumbs = () => {
  const matches = useMatches() as MatchesProps[];

  const titleQueries = matches
    .filter((match) => match.data?.getTitle)
    .map((match) => {
      return {
        queryKey: ['breadcrumb-title', match.id, match.pathname],
        queryFn: () => match.data?.getTitle?.() || null,
        staleTime: Infinity,
        matchId: match.id,
      };
    });

  const titles = useQueries({ queries: titleQueries });

  return titleQueries
    .map((query, index) => {
      const match = matches.find((match) => match.id === query.matchId);

      return { match: match, titleQuery: titles[index] };
    })
    .filter(({ match, titleQuery }) => (titleQuery?.data || titleQuery?.isLoading) && match) as {
    match: MatchesProps;
    titleQuery: UseQueryResult<string>;
  }[];
};
